import { apiCredSystem } from '~/credsystem/services/apiCredSystem';

interface ValidatesPinCodeUseCaseParams {
  pinCode: string;
}

interface APIResponse {
  httpStatusCode: number;
  data: {
    tokenSMS: {
      tokenSmsValido: boolean;
    };
    biometria: {
      mensagem: string;
    };
    fingerPrint: {
      mensagem: string;
    };
  };
}

export async function validatesPinCodeUseCase({
  pinCode,
}: ValidatesPinCodeUseCaseParams): Promise<APIResponse | null> {
  try {
    const response = await apiCredSystem.post<APIResponse>(
      `/api/v1/identificacao/token-sms`,
      {
        pinCode: pinCode,
      }
    );

    return response?.data;
  } catch (error) {
    return null;
  }
}
